<div class="data-container">
  <h4>Datos personales</h4>
  <p class="sub-title">Información personal del usuario.</p>
  <!-- General -->
  <div class="grid-col-3">
    <!-- Documento -->
    <div class="input-container">
      <span class="label">{{
        viewProfileForm.get('documentType').value === DOC_TYPE.RUT
          ? 'RUT'
          : 'CI'
      }}</span>
      <label class="data">{{
        viewProfileForm.get('documentId').value || '-'
      }}</label>
    </div>

    <!-- Nombre / Razón social -->
    <div class="input-container">
      <span class="label">{{
        viewProfileForm.get('documentType').value === DOC_TYPE.RUT
          ? 'Razón social'
          : 'Nombre'
      }}</span>
      <label class="data">{{
        viewProfileForm.get('firstName').value || '-'
      }}</label>
    </div>

    <!-- Apellido -->
    <div
      *ngIf="viewProfileForm.get('documentType').value === DOC_TYPE.CI"
      class="input-container"
    >
      <span class="label">Apellido</span>
      <label class="data">{{
        viewProfileForm.get('lastName').value || '-'
      }}</label>
    </div>
  </div>
  <div class="grid-col-3">
    <!-- Celular -->
    <div class="input-container">
      <span class="label">Celular</span>
      <label class="data">{{
        viewProfileForm.get('cellPhone').value || '-'
      }}</label>
    </div>

    <!-- Email -->
    <div class="input-container">
      <span class="label">Email</span>
      <label class="data">{{
        viewProfileForm.get('email').value || '-'
      }}</label>
    </div>

    <!-- Dirección -->
    <div class="input-container">
      <span class="label">Dirección</span>
      <label class="data">{{
        viewProfileForm.get('address').value || '-'
      }}</label>
    </div>
  </div>

  <hr *ngIf="hasRole('Asegurado')" />
  <!-- Datos adicionales para asegurado -->
  <div *ngIf="hasRole('Asegurado')" class="grid-col-3 section">
    <h5>Datos adicionales del asegurado</h5>
    <p class="sub-title">Información adicional para el rol de asegurado.</p>
    <!-- Card code -->
    <div class="input-container">
      <span class="label">Card code</span>
      <label class="data">{{
        viewProfileForm.get('insuredCardCode').value || '-'
      }}</label>
    </div>
  </div>

  <!-- Datos adicionales para corredores -->
  <div *ngIf="hasRole('Corredor')" class="grid-col-3 section">
    <h5>Datos adicionales del corredor</h5>
    <p class="sub-title">Información adicional para el rol de corredor.</p>
    <!-- RUT -->
    <div class="input-container">
      <span class="label">RUT</span>
      <label class="data">{{ viewProfileForm.get('rut').value || '-' }}</label>
    </div>

    <!-- Card code -->
    <div class="input-container">
      <span class="label">Card code</span>
      <label class="data">{{
        viewProfileForm.get('cardCode').value || '-'
      }}</label>
    </div>
  </div>

  <!-- Datos adicionales para despachante de aduana -->
  <div *ngIf="hasRole('Despachante')" class="grid-col-3 section">
    <h5>Datos adicionales del despachante de aduana</h5>
    <p class="sub-title">
      Información adicional para el rol de despachante de aduana.
    </p>
    <!-- Card code -->
    <div class="input-container">
      <button
        class="button button-blue-outline dispatchers-button"
        (click)="showDispatcherList()"
      >
        <i class="pi pi-eye"></i>
        Ver empresas gestionadas
      </button>
    </div>
  </div>
</div>
